var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolarPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M73.751,55.552l-4.896-25.48c-0.181-0.942-1.005-1.623-1.964-1.623H54.808H41.192H29.108c-0.959,0-1.783,0.681-1.964,1.623 l-4.896,25.48c-0.113,0.585,0.042,1.19,0.422,1.65s0.945,0.727,1.542,0.727h15.215h6.55v5.622H37.96c-1.104,0-2,0.896-2,2 s0.896,2,2,2h20.036c1.104,0,2-0.896,2-2s-0.896-2-2-2h-8.019v-5.622h6.595h15.215c0.597,0,1.162-0.267,1.542-0.727 S73.863,56.137,73.751,55.552z M29.129,40.942h9.332l-0.311,4.493h-9.884L29.129,40.942z M42.47,40.942h11.059l0.311,4.493H42.159 L42.47,40.942z M57.539,40.942h9.332l0.863,4.493H57.85L57.539,40.942z M66.103,36.942h-8.841l-0.311-4.493h8.288L66.103,36.942z  M52.941,32.449l0.311,4.493H42.747l0.311-4.493H52.941z M39.049,32.449l-0.311,4.493h-8.84l0.863-4.493H39.049z M27.497,49.436 h10.376l-0.311,4.493H26.633L27.497,49.436z M41.571,53.929l0.311-4.493h12.236l0.311,4.493H41.571z M58.438,53.929l-0.311-4.493 h10.376l0.863,4.493H58.438z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarPanel);
export default __webpack_public_path__ + "static/media/solar-panel.0d13b2595446ea83395cce135e9a616d.svg";
export { ForwardRef as ReactComponent };